export default function getSessionId({ session }) {
  let sessionId;
  if (session && session.data) {
    return session.data.sessionId;
  }
  return sessionId;
}
